import React, { useEffect, useState } from 'react';
import UploadProduct from '../components/UploadProduct';
import UploadMultipleProducts from '../components/UploadMultipleProducts';
import SummaryApi from '../common';
import AdminProductCard from '../components/AdminProductCard';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // Loading icon
import { useSelector } from 'react-redux';
import { SiMicrosoftexcel } from "react-icons/si";
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';


const AllProducts = () => {
  const [openUploadProduct, setOpenUploadProduct] = useState(false);
  const [openUploadMultipleProduct, setOpenUploadMultipleProduct] = useState(false);
  const [allProduct, setAllProduct] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const user = useSelector(state => state?.user?.user);
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();


  const fetchAllProduct = async () => {
    try {
      setLoading(true); // Start loading
      const response = await fetch(SummaryApi.allProduct.url);
      const dataResponse = await response.json();

      setAllProduct(dataResponse?.data || []);
    } catch (error) {
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const fetchMedicineProduct = async () => {
    try {
      setLoading(true); // Start loading
      const response = await fetch(SummaryApi.medicineProduct.url,{credentials:'include'});
      const dataResponse = await response.json();

      setAllProduct(dataResponse?.data || []);
    } catch (error) {
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const fetchCosmeticProduct = async () => {
    try {
      setLoading(true); // Start loading
      const response = await fetch(SummaryApi.cosmeticProduct.url,{credentials:'include'});
      const dataResponse = await response.json();

      setAllProduct(dataResponse?.data || []);
    } catch (error) {
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if(user?.type==="Medicine"){
      fetchMedicineProduct();
    }
    else if(user?.type==="Cosmetic"){
      fetchCosmeticProduct();
    }
    else{
      fetchAllProduct();
    }

  }, []);

  const fetchData = user?.type === "Medicine"
  ? fetchMedicineProduct
  : user?.type === "Cosmetic"
  ? fetchCosmeticProduct
  : fetchAllProduct;

  useEffect(() => {
    setLoadingPage(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoadingPage(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.ADMIN) {
        navigate('/');
        setLoadingPage(false);
      } 
      else {
        if(user?.type === "Admin"){
            navigate('/admin-panel/all-users');
            setLoadingPage(false);
        }
        else{
            setLoadingPage(false);
            clearTimeout(loadingTimeout);
        }
       
      }
    } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  if (loadingPage) {
    return (
        <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
        </div>
    );
}

  return (
    <div>
   {/*   <h2 className='font-bold text-lg mb-4'>جميع المنتجات</h2> */}
<div className='bg-white py-2 px-4'>
  
  
  <div className='flex flex-col items-end gap-4'>
    <button
      className='flex items-center bg-blue-900 text-white py-2 px-4 rounded-lg shadow-md transition duration-200 ease-in-out hover:bg-blue-700 hover:shadow-lg'
      onClick={() => setOpenUploadProduct(true)}
    >
      إضافة منتج جديد
    </button>

    <button
    className="flex items-center bg-green-600 text-white py-2 px-4 rounded-lg shadow-md transition duration-200 ease-in-out hover:bg-green-700 hover:shadow-lg"
    onClick={() => setOpenUploadMultipleProduct(true)}
>
    <SiMicrosoftexcel className="mr-2 text-lg" />
    Excel اضف منتجات جديدة عبر 
</button>
  </div>
</div>


      



      {/** All products section */}
      <div >
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
          </div>
        ) : allProduct.length === 0 ? (
          <p className="text-center text-gray-500">لا يوجد منتجات</p>
        ) : (
          <div className='flex items-center flex-wrap gap-5'>
            {allProduct.map((product, index) => (
              <AdminProductCard
                userType={user?.type}
                data={product}
                key={index + "allProduct"}
                fetchdata={fetchData}
              />
            ))}
          </div>
        )}
      </div>

      {/** Upload product component */}
      {openUploadProduct && (
        <UploadProduct userType={user?.type} onClose={() => setOpenUploadProduct(false)} fetchData={fetchData} />
      )}

            {/** Upload product component */}
            {openUploadMultipleProduct && (
        <UploadMultipleProducts userType={user?.type} onClose={() => setOpenUploadMultipleProduct(false)} fetchData={fetchData} />
      )}
    </div>
  );
};

export default AllProducts;
